import React, { FC } from 'react';
import { Button } from 'antd';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { passwordResetRequest } from '~/routes';

import { ResetPasswordEmailSentIcon } from '~/img';
import PasswordResetLayout from '~/layout/PasswordResetLayout';
import theme from '~/theme';

const PasswordResetEmailSent: FC<RouteComponentProps> = () => {
  const { t } = useTranslation('passwordReset');
  const history = useHistory();

  const onClick = () => {
    history.replace(`/${passwordResetRequest}`);
  };

  return (
    <Container>
      <PasswordResetLayout
        icon={<ResetPasswordEmailSentIcon />}
        title={t('Check your email')}
        subtitle={t('We have sent a password recover instructions to your email address.')}
        withGoToLogin
      >
        <div className="PasswordResetEmailSent-TryAgainContainer">
          <div className="PasswordResetEmailSent-TryAgainContainerText">
            {t('Did not receive the email?')}
          </div>
          <Button
            className="PasswordResetEmailSent-TryAgainContainerLinkButton"
            type="link"
            size="large"
            onClick={onClick}
          >
            {t('Try again')}
          </Button>
        </div>
      </PasswordResetLayout>
    </Container>
  );
};

const Container = styled.div`
  .PasswordResetEmailSent-TryAgainContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: -16px;
    margin-top: 16px;
    .PasswordResetEmailSent-TryAgainContainerText {
      color: ${theme.disabledColor};
    }
    .PasswordResetEmailSent-TryAgainContainerLinkButton {
      padding: 0;
      font-size: 14px;
      height: 22px;
    }
  }
`;

export default PasswordResetEmailSent;
